// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"FormContainer_formContainer__XTKHB"};